import type { Components, Theme } from '@mui/material';

import { colors } from '@verantos-dev/shared-ui-components/tokens';

export const theme: Components<Theme>['MuiChip'] = {
  styleOverrides: {
    colorPrimary: {
      backgroundColor: colors['primary-500'],
    },
    colorSecondary: {
      backgroundColor: colors['secondary-500'],
    },
    colorSuccess: {
      backgroundColor: colors['success-500'],
    },
    colorInfo: {
      backgroundColor: colors['info-500'],
    },
    colorWarning: {
      backgroundColor: colors['warning-500'],
    },
    colorError: {
      backgroundColor: colors['error-500'],
    },
  },
};

export const muiChipThemeConfig = {
  MuiChip: {
    ...theme,
  },
};
